// extracted by mini-css-extract-plugin
module.exports = {"content":"src-components-flowable-IRBStudy-StudySearch___content","cardMargin":"src-components-flowable-IRBStudy-StudySearch___cardMargin"};